export default {
  title: 'Deposit',
  alert: {
    message: 'Please complete the profile to unlock all deposit/withdrawal methods',
    'button-text': 'Go to complete',
  },
  'currency-type': {
    title: 'Payment Currency',
  },
  'payment-method': {
    title: 'Payment Method',
  },
  'pay-page': {
    title: 'Deposit Amount',
    form: {
      pay_type_id: {
        label: 'Payment Method',
        placeholder: 'Please select payment method',
      },
      wallet_id: {
        label: 'Select Account',
        placeholder: 'Please select account',
        account_type: {
          main: 'Wallet Account',
          MT: 'MT Account',
          MT4: 'MT4',
          MT5: 'MT5',
        },
        account_detail: '{wallet_id}-{balance} {currency}',
      },
      amount: {
        label: 'Deposit Amount',
        labelUnverified: 'Deposit Amount(Max {amount}USD)',
        placeholder: 'Please enter deposit amount',
        rule: {
          required: 'Please enter deposit amount',
          min: 'Input amount is less than the minimum deposit amount',
          limit: 'Not passed KYC deposit amount cannot exceed {amount}USD',
        },
      },
      certificate: {
        label: 'Deposit Certificate',
        placeholder: 'Please select deposit certificate',
        rule: {
          required: 'Please select deposit certificate',
        },
      },
      tips: {
        title: 'Arrival Amount',
        rate: 'Exchange Rate',
      },
      submit: 'Submit',
      message: {
        limit: 'Deposit amount exceeds the maximum limit',
        error: 'Deposit amount exceeds the maximum limit',
      },
    },
    modal: {
      'deposit-success': {
        title: 'Go to Pay',
        message:
          'Please click "Go to Pay" to enter the third-party platform to complete the payment.',
        confirm: 'Go to Pay',
        cancel: 'Cancel',
        error: 'Payment failed, please try again later',
      },
    },
  },
}
